import React, { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { Switch } from '../../../components';
import { i18n } from '../../../helpers/i18n';
import { useActions } from '../../../hooks';
import { selectJoinWithMicrophoneOff, toggleJoinWithMicrophoneOffAction } from '../../settings';
import css from './styles.css';

export const JoinWithMicrophoneOffSwitch = () => {
    const actions = useActions({ toggleJoinWithMicrophoneOffAction });

    const joinWithMicrophoneOff = useSelector(selectJoinWithMicrophoneOff);

    const onChange = useCallback(
        () => actions.toggleJoinWithMicrophoneOffAction(!joinWithMicrophoneOff),
        [actions, joinWithMicrophoneOff]
    );

    return (
        <Switch
            labelBefore={i18n('settings', 'join-with-microphone-off')}
            className={css.switch}
            checked={joinWithMicrophoneOff}
            onChange={onChange}
            size="sm"
            stretch
            shrink
        />
    );
};
